export default __webpack_public_path__ + "static/media/exclamation.ad69fce4.png";